import { Component } from '@angular/core';
import {CommandComponent} from "../command-component";

/**
 * Generated class for the CommandListComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'list-commands',
  template:'<div  *ngFor="let c of commandList">{{c}}</div>'
})
export class ListCommandsComponent implements CommandComponent{

  text: string;
  commandList:Array<any>;
  type:string;


  constructor() {
    console.log('Hello CommandListComponent Component');
    this.text = 'Hello World';
  }

  public setData(data){
    debugger;
    this.commandList = data;
  }
}



// WEBPACK FOOTER //
// ./src/components/commands/list-commands/list-commands.ts